export default __webpack_public_path__ + "580a83c3fc2ef6553245b0fdd22268aa.svg";